import service from './axios';

// ===== 房型管理 =====
export const getRoomTypes = (params = {}) => service.get('/manage/rooms', { params });
export const getRoomType = (id) => service.get(`/manage/rooms/${id}`);
export const createRoomType = (data) => service.post('/manage/rooms', data);
export const updateRoomType = (id, data) => service.put(`/manage/rooms/${id}`, data);
export const deleteRoomType = (id) => service.delete(`/manage/rooms/${id}`);

// ===== 特殊日期价格 =====
export const getSpecialPrices = (roomTypeId) => service.get(`/manage/rooms/${roomTypeId}/special-prices`);
export const upsertSpecialPrice = (roomTypeId, data) => service.post(`/manage/rooms/${roomTypeId}/special-prices`, data);
export const deleteSpecialPrice = (roomTypeId, id) => service.delete(`/manage/rooms/${roomTypeId}/special-prices/${id}`);

// ===== 增项服务管理 =====
export const getExtraServices = (params = {}) => service.get('/manage/extra-services', { params });
export const getExtraService = (id) => service.get(`/manage/extra-services/${id}`);
export const createExtraService = (data) => service.post('/manage/extra-services', data);
export const updateExtraService = (id, data) => service.put(`/manage/extra-services/${id}`, data);
export const deleteExtraService = (id) => service.delete(`/manage/extra-services/${id}`);
